<script setup lang="ts">
type Status =
  | "pending"
  | "rejected"
  | "approved"
  | "active"
  | "completed"
  | "inactive"

const props = withDefaults(
  defineProps<{
    status?: Status
  }>(),
  {
    status: "pending",
  },
)

const statusesMap: Record<Status, { label: string; class: string }> = {
  pending: {
    label: "En revisión",
    class: "bg-[#FFF9DC] text-[#B39918] border border-[#B39918]",
  },
  inactive: {
    label: "Inactive",
    class: "bg-[#FFF9DC] text-[#B39918] border border-[#B39918]",
  },
  rejected: {
    label: "Rechazado",
    class: "bg-[#FFE3E3] text-[#D14343] border border-[#D14343]",
  },
  approved: {
    label: "Aprobado",
    class: "bg-[#E3FFEC] text-[#409D5F] border border-[#409D5F]",
  },
  completed: {
    label: "Completed",
    class: "bg-[#E3FFEC] text-[#409D5F] border border-[#409D5F]",
  },
  active: {
    label: "Active",
    class: "bg-[#E3FFEC] text-[#409D5F] border border-[#409D5F]",
  },
}
</script>

<template>
  <div
    class="flex justify-center rounded-lg px-2 py-1 text-sm font-medium"
    :class="statusesMap[props.status].class"
  >
    <p class="text-xs">
      {{ statusesMap[props.status].label.toLocaleUpperCase() }}
    </p>
  </div>
</template>
